import { useMutation, useQueryClient } from 'react-query';
import { CustomerAgreementsApi } from '../CustomerAgreementsApi';
import {
    CustomerAgreementAssignmentQueryKey,
    CustomerAgreementQueryKey,
    CustomerAgreementsQueryKey
} from '../queryKeys';
import { refetchChangedQueries } from './refetchChangedQueries';
import { CustomerAgreement, UpdateCustomerAgreementInput } from '../types';

export type UpdateCustomerAgreement = (
    id: number,
    input: UpdateCustomerAgreementInput
) => Promise<CustomerAgreement>;

type UpdateVariables = { id: number; input: UpdateCustomerAgreementInput };

export function useUpdateCustomerAgreementMutation(): UpdateCustomerAgreement {
    const queryClient = useQueryClient();

    const mutation = useMutation<CustomerAgreement, unknown, UpdateVariables>(
        ({ id, input }) => CustomerAgreementsApi.updateCustomerAgreement(id, input),
        {
            onSuccess: (updated, { id }) =>
                refetchChangedQueries(queryClient, [
                    [CustomerAgreementsQueryKey],
                    [CustomerAgreementQueryKey, id],
                    [CustomerAgreementAssignmentQueryKey]
                ])
        }
    );

    return function updateCustomerAgreement(id: number, input: UpdateCustomerAgreementInput) {
        return mutation.mutateAsync({ id, input });
    };
}
